import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as state from '../../../../../state'

import * as agentsTab from './agents-tab'
import * as generalTab from './general-tab'
import * as usersTab from './users-tab'
import * as zonesTab from './zones-tab'

@ngCore.Component({
  imports: [
    ds.tabs.floatingHorizontal.Component,
    ds.tabs.tab.Directive,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    generalTab.Component,
    zonesTab.Component,
    usersTab.Component,
    agentsTab.Component,
  ],
  selector: 'atn-admin-tenant-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.tenants.Collection} */
  public readonly tenantsEc = ngCore.inject(state.admin.tenants.Collection)

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Name of selected tenant*/
  public readonly tenantNameSg = ngCore.computed(
    (
      tenant = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => tenant?.name,
  )
  /** Alias of selected tenant*/
  private readonly _tenantAliasSg = ngCore.computed(
    (
      tenant = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => tenant?.alias,
  )

  /**
   * Breadcrumbs displayed in page header
   */
  public readonly breadcrumbsSg = ngCore.computed(() => {
    const alias = this._tenantAliasSg()
    return [
      {
        name: 'Tenants',
        url: this._router.ngRouter.createUrlTree(['/admin/tenants']),
      },
      {
        name: this.tenantNameSg() ?? alias ?? '',
      },
    ] satisfies readonly ds.layout.page.child.header.models.Breadcrumb[]
  })

  /** Whether the Users tab is available for the current admin user */
  public readonly canManageUsersSg = ngCore.computed(
    (
      context = this._contextsFeature.selectors.activeEntityContext.asSignal(),
      currentUser = this._meFeature.selectors.currentUser.asSignal(),
    ) =>
      state.admin.userAssignment.models.User.canManageUsersForContext(
        currentUser,
        context,
      ),
  )
}
